import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ReportsPage.css'; // Import styling for the Reports page
import apiClient from '../../utils/apiClient';

// 🔹 Function to retrieve `browserId` from cookies (set by backend)
const getCookieValue = (cookieName) => {
    return document.cookie.split('; ').find(row => row.startsWith(`${cookieName}=`))?.split('=')[1];
};

// 🔹 Ensure `deviceId` is stored in `localStorage`
if (!localStorage.getItem("deviceId")) {
    localStorage.setItem("deviceId", crypto.randomUUID());
}
const deviceId = localStorage.getItem("deviceId");

// 🔹 Retrieve `browserId` from cookies
const browserId = getCookieValue("browserId");

// i18n note: this legacy report launcher keeps its behavior unchanged;
// only visible labels/messages are read from translation dictionaries.
const ReportsPage = () => {
    const { t } = useTranslation(["common", "reports"]);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleGenerateReport = async () => {
        try {
            // 🔹 Call backend API to generate the report
            const response = await apiClient.post('/reports/generate', {}, {
                headers: {
                    'Device-Id': deviceId,
                    'Browser-Id': browserId,
                },
                withCredentials: true, // Ensure cookies are sent
            });

            setSuccessMessage(t('reports:reportsPage.generateSuccess', { message: response.data.message || '' }).trim());
            setError('');
        } catch (err) {
            console.error('[ReportsPage] Error generating report:', err);
            setError(t('reports:reportsPage.generateError'));
            setSuccessMessage('');
        }
    };

    return (
        <div className="reports-page">
            <h1>{t("reports:reportsPage.title")}</h1>
            <p>{t("reports:reportsPage.description")}</p>
            <button onClick={handleGenerateReport} className="generate-report-button">
                {t("reports:reportsPage.generateButton")}
            </button>
            {error && <p className="error-message">{error}</p>}
            {successMessage && <p className="success-message">{successMessage}</p>}
        </div>
    );
};

export default ReportsPage;
